// ============================================================================
// Constantes de tracking (noms d'événements PostHog)
// ============================================================================

export const TRACKING_EVENTS = {
  PAGE_VIEW: 'page_view',
  PAGE_LEAVE: 'page_leave',
  CTA_CLICK: 'cta_click',
  FORM_OPENED: 'form_opened',
  FORM_STEP_COMPLETED: 'form_step_completed',
  FORM_PARTIAL_SUBMISSION: 'form_partial_submission',
  FORM_SUBMISSION: 'form_submission',
  LEAD_QUALIFIED: 'lead_qualified',
  LEAD_DISQUALIFIED: 'lead_disqualified',
  VSL_UNLOCKED: 'vsl_unlocked',
  // Funnel masterclass : place réservée pour le direct du jeudi.
  // PostHog seul — la conversion pub est déjà portée par `lead_qualified`
  // (mappé Meta `Lead`), qui est émis juste avant avec funnel=masterclass.
  SEAT_CONFIRMED: 'seat_confirmed',
  VSL_CTA_CLICK: 'vsl_cta_click',
  CAL_MODAL_OPENED: 'cal_modal_opened',
  BOOKING_UNAVAILABLE: 'booking_unavailable',
  APPLICATION_SUBMITTED: 'application_submitted',
} as const;
